import axios from '@/plugins/axios'


export default {
    state: {
        docTypes: {},
        selectedArticles: [],
        selectedTopics: []
    },
    mutations: { 
        setDocTypes(state, docTypes){
            state.docTypes = docTypes
        },
        updateSelectedForDownload(state, data){
            Object.assign(state, data)
        },
    },
    actions: {
        async fetchDocTypes() {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/GetTemplates", {})
                    .then((res) => {
                        return res.data
                    })
                    .finally(() => {
                    });
            } catch (e) {
                throw e
            }
        },
        async getDocumentData(state, data) {
            let allSelected = []
            allSelected.push(...state.state.selectedArticles, ...state.state.selectedTopics);

            let docIDs = allSelected.map((article) => article.id);
            let templateID = data;
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/QuickGenerateDocs", {templateID, docIDs})
                    .then((res) => {
                        return res.data 
                    })
                    .finally(() => {
                        console.log('finaly');
                    });
            } catch (e) {
                throw e
            }
        },
    },
    getters: {
        docTypes(state) {
            return state.docTypes
        },
        selectedArticles(state) {
            return state.selectedArticles
        }
    
    }
}